module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<table class="ngeo-colorpicker-palette">\n  <tr ng-repeat="colors in ::ctrl.colors">\n    <td\n      ng-repeat="color in ::colors"\n      ng-click="ctrl.setColor(color)"\n      ng-class="{\'ngeo-colorpicker-selected\': color == ctrl.color}"\n    >\n      <div ng-style="::{\'background-color\': color}"></div>\n    </td>\n  </tr>\n</table>\n';

}
return __p
}